import type { RadioButtonTokens } from './types';

export const radioButton: RadioButtonTokens = {
  borders: {
    default: '1',
  },
  colors: {
    label: 'neutral.70',
    tick: {
      default: {
        iconColor: 'neutral.10',
        bgColor: 'neutral.10',
        borderColor: 'neutral.50',
        hover: {
          borderColor: 'primary.50',
        },
      },
      error: {
        iconColor: 'critical.70',
        bgColor: 'critical.20',
        labelColor: 'neutral.70',
        borderColor: 'critical.90',
      },
      disabled: {
        iconColor: 'neutral.50',
        bgColor: 'neutral.30',
        borderColor: 'neutral.40',
      },
      checked: {
        iconColor: 'neutral.10',
        bgColor: 'primary.50',
        borderColor: 'primary.50',
        hover: {
          borderColor: 'primary.50',
        },
      },
    },
    circle: {
      default: {
        iconColor: '',
        bgColor: 'neutral.10',
        borderColor: 'neutral.50',
        hover: {
          borderColor: 'primary.50',
        },
      },
      error: {
        bgColor: 'critical.20',
        borderColor: 'critical.90',
        iconColor: 'critical.70',
        labelColor: 'neutral.70',
      },
      disabled: {
        bgColor: 'neutral.30',
        borderColor: 'neutral.50',
        iconColor: 'neutral.50',
      },
      checked: {
        bgColor: 'neutral.10',
        borderColor: 'neutral.50',
        iconColor: 'primary.50',
        hover: {
          borderColor: 'primary.50',
        },
      },
    },
  },
  sizes: {
    minWidth: '1',
    height: '1',
  },
  lineHeight: {
    default: 'bodies.base',
  },
  fontSizes: {
    default: '2',
  },
  fontWeights: {
    unchecked: 'normal',
    checked: 'normal',
  },
};
